import React, {useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import OtpHeadlineComponent from './OtpHeadlineWrapperComponent';
import {changePhoneInputHandler, onBlurHandler} from './otpAuthenticationSlice';
import TextInput from '../../Shared/TextInput/TextInput';

const OtpVerifyPhoneComponent = (props) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      setImmediate(() => {
        ref.current?.focus();
      });
    }

    //GA
    if (props.gaStep1Display) {
      props.gaStep1Display();
    }
  }, []);

  return (
    <Container className='pr-0 pl-0'>
      <Col className='col-12 pr-0 pl-0'>
        <OtpHeadlineComponent
          title={props.otpTitles?.verifyPhoneTitle || 'הכניסו את פרטיכם כדי שנוכל להתקדם'}
          description={props.otpTitles?.verifyPhoneDescription}
        />
      </Col>

      <Col className='col-12 otp-verify-phone pr-0 pl-0'>
        <TextInput
          ref={ref}
          className='otp-phone-input'
          name='phone'
          type='tel'
          pattern='[0-9]*'
          id='phone'
          maxLength='10'
          autoComplete='off'
          placeholder={'טלפון נייד'}
          required='required'
          value={props.otp.otpPhoneForm.phone}
          error={props.otp.otpPhoneForm.errors.phone}
          onBlur={(e) => props.onBlurHandler({target: e.target, form: props.otp.otpPhoneForm, formName: 'otpPhoneForm'})}
          onChange={(e) => props.changePhoneInputHandler({target: e.target, form: props.otp.otpPhoneForm})}
        />
        {props.otp.showWrongOtpCodeMessage && <div className='error' dangerouslySetInnerHTML={{__html: props.otp.wrongOtpMessage}}></div>}
      </Col>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    otp: state.otpAuthentication,
  };
};

const mapDispatchToProps = {
  changePhoneInputHandler,
  onBlurHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyPhoneComponent);
